import { useState, useEffect } from 'react'
import { AddOptions } from 'components/ideal-core-ui'
import { toLeadItems, toLeadItem } from './serializers'
import s from './LeadsModule.scss'
import { makeLeadsGetRequest, makeLeadsPutRequest } from 'utils/api'
import { useDispatch } from 'react-redux'
import { setModules, getModules, getPaymentOverdueDate } from 'utils/paymentService'

const LeadsModule = () => {
  const [enabled, setEnabled] = useState(false)
  const dispatch = useDispatch()
  const isDisabled = getPaymentOverdueDate()

  useEffect(() => {
    ;(async () => {
      const { moduleEnabled } = await makeLeadsGetRequest('/v1/settings')
      setEnabled(moduleEnabled)
    })()
  }, [])

  const toggleEnabled = async status => {
    try {
      await makeLeadsPutRequest('/v1/settings', { moduleEnabled: status })
      setEnabled(status)
      setModules({ ...getModules(), leads: status })
      dispatch({
        type: 'PUSH_NOTIFICATION',
        payload: {
          title: 'Organization updated successfuly',
          level: 'success'
        }
      })
      dispatch({
        type: 'REFRESH_HEADER'
      })
    } catch (e) {
      dispatch({
        type: 'PUSH_NOTIFICATION',
        payload: {
          title: 'An error occurred. Please contact support',
          level: 'error'
        }
      })
    }
  }

  return (
    <>
      <h5>Leads Module</h5>
      <p className={s.description}>
        The iDeal Leads module allows you to manage your leads and prospects separately from your
        contacts, companies, and opportunities.
        <br />
        <br />
        The Leads module is charged once a month for your entire organization, depending on your
        subscription type. $19 for 1-User organization; $49 for 2-10 Users organization; and $79 for
        11+ Users organization.
        <br />
        <br />
        When you turn the Leads module On, you will enter a trial period until your next billing
        cycle so you won&#39;t be charged immediately. You&#39;ll have the opportunity to test the
        functionality, and leave it on if it&#39;s something you want to use. If you turn if Off
        before your next billing cycle, you will not be charged for it.
        <br />
        <br />
        If you have any questions about billing, please don&#39;t hesitate to contact Alex at
        alex@idealcrm.app
      </p>
      <div className={s.inputContainer}>
        <input
          disabled={isDisabled}
          type="radio"
          checked={enabled}
          onChange={() => toggleEnabled(true)}
        />{' '}
        On
      </div>
      <div className={s.inputContainer}>
        <input
          disabled={isDisabled}
          type="radio"
          checked={!enabled}
          onChange={() => toggleEnabled(false)}
        />{' '}
        Off
      </div>
      <hr />
      <AddOptions
        texts={{
          title: 'Lead Status',
          subtitle: 'Lead Status Options',
          description: 'Use the lead status to organize your leads into a pipeline.'
        }}
        url="/v1/status"
        app="leads"
        toItemSerializer={toLeadItem}
        toItemsSerializer={toLeadItems}
        itemsType="leads"
      />
      <AddOptions
        texts={{
          title: 'Lead Source',
          subtitle: 'Lead Source Area Options',
          description:
            'Lead source can help report on the best sources for your leads so you know where to invest more time and money.'
        }}
        url="/v1/source"
        app="leads"
        toItemSerializer={toLeadItem}
        toItemsSerializer={toLeadItems}
        itemsType="leads"
      />
      <AddOptions
        texts={{
          title: 'Lead Tags',
          subtitle: 'Lead Tags Options',
          description:
            'Use tags as additional filters for your specific needs. Tags can be anything from interests to actions they took on your website or how they replied to one of your campaigns. You can assign multiple tags to a lead.'
        }}
        url="/v1/tag"
        app="leads"
        toItemSerializer={toLeadItem}
        toItemsSerializer={toLeadItems}
        itemsType="leads"
      />
      <AddOptions
        texts={{
          title: 'Lead State',
          subtitle: 'Lead State Options',
          description:
            'The state of a lead helps you prioritize your leads in terms of probability of close. A Hot lead is more likely to close than a Warm one.'
        }}
        url="/v1/state"
        app="leads"
        toItemSerializer={toLeadItem}
        toItemsSerializer={toLeadItems}
        itemsType="leads"
      />
    </>
  )
}

export default LeadsModule
